var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14.25L15 18L9 16.5L3.75 12.75",
    stroke: "#132A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81372 6.62156L12 5.25L17.1862 6.62156",
    stroke: "#132A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2222 5.66427L0.829696 10.4511C0.740781 10.6289 0.726087 10.8348 0.788844 11.0234C0.851601 11.212 0.986674 11.368 1.16438 11.4571L3.75001 12.7499L6.81376 6.62146L4.22907 5.32958C4.14099 5.28541 4.04507 5.25903 3.94679 5.25194C3.8485 5.24486 3.74979 5.25721 3.65628 5.28829C3.56278 5.31937 3.47631 5.36857 3.40183 5.43309C3.32735 5.4976 3.26631 5.57616 3.2222 5.66427Z",
    stroke: "#132A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12.7499L22.8357 11.4571C23.0134 11.368 23.1484 11.212 23.2112 11.0234C23.2739 10.8348 23.2593 10.6289 23.1703 10.4511L20.7778 5.66427C20.7337 5.57616 20.6727 5.4976 20.5982 5.43309C20.5237 5.36857 20.4373 5.31937 20.3438 5.28829C20.2502 5.25721 20.1515 5.24486 20.0533 5.25194C19.955 5.25903 19.859 5.28541 19.771 5.32958L17.1863 6.62146L20.25 12.7499Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2499 6.75H13.4999L9.21932 10.9022C9.13974 10.9817 9.07908 11.0781 9.04182 11.1843C9.00457 11.2905 8.99167 11.4037 9.0041 11.5155C9.01652 11.6273 9.05395 11.7349 9.1136 11.8303C9.17325 11.9257 9.2536 12.0064 9.34869 12.0666C10.9903 13.1156 13.2187 13.0434 14.9999 11.25L18.7499 14.25L20.2499 12.75",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6306 20.25L7.71937 19.2722L5.25 17.5078",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_4366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/Handshake.87442dff4455a5ea58408c7e8b3b893b.svg";
export { ForwardRef as ReactComponent };